<template>
  <div class="dashMobile">
    <nav class="navbar nav-dashMobile" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <a class="navbar-item">
          <img
            src="../../assets/images/virtualred-logo/favicon/Favicon-128x.png"
            class="icon-nav-mobile"
          />
        </a>

        <a
          role="button"
          onclick="document.getElementById('nav-active').classList.toggle('is-active');"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
    </nav>
    <div class="navbar-menu" id="nav-active">
      <aside class="menu">
        <ul class="menu-list">
          <li>
            <router-link to="/dashaluno" style="margin-left:-13px;">
              <a>
                <img src="../../assets/images/icon-color/home.svg" style="position: absolute;" />
                <span class="menu-li-text-active">Painel</span>
              </a>
            </router-link>
            <a>
              <img src="../../assets/images/icon-color/file.svg" class="menu-li-img" />
              <span class="menu-li-text">Minhas Redações</span>
            </a>
            <a>
              <img src="../../assets/images/icon-color/propostas.svg" class="menu-li-img" />
              <span class="menu-li-text">Propostas</span>
            </a>
            <a>
              <img src="../../assets/images/icon-color/simulado.svg" class="menu-li-img" />
              <span class="menu-li-text">Simulados</span>
            </a>
            <hr />
            <a>
              <img src="../../assets/images/icon-color/videoaulas-1.svg" class="menu-li-img" />
              <span class="menu-li-text">Videoaulas</span>
            </a>
            <a>
              <img src="../../assets/images/icon-color/tutoriais-1.svg" class="menu-li-img" />
              <span class="menu-li-text">Tutoriais</span>
            </a>
            <a>
              <img src="../../assets/images/icon-color/materiais-1.svg" class="menu-li-img" />
              <span class="menu-li-text">Materiais</span>
            </a>
            <a>
              <img src="../../assets/images/icon-color/folha_redacao-1.svg" class="menu-li-img" />
              <span class="menu-li-text">Folhas de Redação</span>
            </a>
            <router-link class="profile-menu" to="/login">
              <a v-on:click="logout">
                <img src="../../assets/images/icon-color/user.svg" class="profile-img-menu" />
                <span class="profile-name-menu">{{name}}</span>
                <div class="profile-type-menu">
                  <span>ALUNO</span>
                </div>
                <img
                  src="../../assets/images/icon-color/logout.svg"
                  class="profile-img-menu profile-img-exit"
                />
              </a>
            </router-link>
          </li>
        </ul>
      </aside>
    </div>
  </div>
</template>
<script>
import store from "@/store";
import AuthService from "@/services/AuthService";

export default {
  data() {
    return {
      cargo: store.getters.cargo,
      name: store.getters.name
    };
  },
  methods: {
    logout() {
      this.isLoading = true;
      AuthService.logout({})

        .then(() => {
          this.$buefy.toast.open({
            duration: 5000,
            message: "logout realizado com sucesso!",
            position: "is-top-right",
            type: "is-success"
          });
        })
        .catch(() => {})
        .finally(() => {});
    }
  }
};
</script>